export default __webpack_public_path__ + "static/media/Circlet of the Unutterable.0dca475e.jpg";